import React, { Fragment, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-awesome-modal'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

import Maps from './GoogleMaps'
import { ComunidadeIuppService as Service } from '../Services/ComunidadeIupp'
import StoreShowCase from './newShowCase/StoreShowCase'
import OfferShowCase from './newShowCase/OfferShowCase'
import * as Selectors from './selectors'
import * as Actions from './actions'

function HomeIupp ({
  participant,
  stores,
  physicalOffers,
  ecommerceOffers,
  zipCode,
  location,
  isLoadingStores,
  isLoadingOffers,
  useLocation,
  setLocation,
  getStoreShowcase,
  getOfferShowCase,
  setZipCode,
  setUseLocation,
  getLocationFromZipCode
}) {
  const [isModalVisible, setIsModalVisible] = useState(false)

  useEffect(() => {
    verifyToken()
  }, [])

  useEffect(() => {
    async function handleZipCode () {
      await verifyToken()
      setZipCode(participant.address.zipCode.value)
      await getLocationFromZipCode()
      search()
    }

    if (participant.address.zipCode.value && !useLocation) {
      handleZipCode()
    }
  }, [participant])

  const verifyToken = async () => {
    await Service.tokenVerify()
  }

  const getLocation = () => {
    navigator.geolocation.getCurrentPosition(
      getLocationSuccess,
      getLocationError
    )
  }

  const getLocationSuccess = ({ coords: { latitude, longitude } }) => {
    setUseLocation(true)
    setLocation({ latitude, longitude })
    search()
    closeUseLocationModal()
  }

  const getLocationError = () => {
    setUseLocation(false)
    search()
    closeUseLocationModal()
  }

  const handleDontUseLocation = () => {
    closeUseLocationModal()
    setUseLocation(false)
    search()
  }

  const search = () => {
    getStoreShowcase()
    getOfferShowCase('physicalOffers')
    getOfferShowCase('ecommerceOffers')
  }

  const openUseLocationModal = () => setIsModalVisible(true)

  const closeUseLocationModal = () => setIsModalVisible(false)

  const handleRedirectToSignUp = () => {
    window.location.href = `https://${process.env.REACT_APP_COMUNIDADE_IUPP_SIGNUP}`
  }

  const redirectToSearch = () => {
    window.location.href = `/comunidade-iupp/search${zipCode ? `?zipcode=${zipCode}` : ''}`
  }

  return (
    <Fragment>
      <Modal
        visible={isModalVisible}
        width='580'
        height='250'
        effect='fadeInUp'
      >
        <div className='ModalAlertLocal'>
          <div className='headerLocal'>
            <h1>queremos mostrar ofertas próximas de você.</h1>
          </div>
          <div className='bodyLocal'>
            <p>
              para isso precisamos que você divida sua localização com a gente.
            </p>
            <div className='btnLocations'>
              <div className='BtnAgoraNao' onClick={handleDontUseLocation}>
                agora não
              </div>
              <div className='BtnAtivarLocalizar' onClick={getLocation}>
                ativar localização
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <div className='container mt-2'>
        <div className='destaque-meu-bairro col-12 col-md-12 bordered radius border-color-ui-3'>
          <p className='pl-3'>
            o itaú incentiva o comércio local.
            <br /> cadastre seu negócio e venda também no iupp.
          </p>
          <div className='btn-vender-link' onClick={handleRedirectToSignUp}>
            quero vender
          </div>
        </div>
        <StoreShowCase
          loading={isLoadingStores}
          stores={stores}
          useLocation={useLocation}
          zipCode={zipCode}
          openLocationModal={openUseLocationModal}
        />
        <OfferShowCase
          type='physicalOffers'
          loading={isLoadingOffers}
          offers={physicalOffers}
          useLocation={useLocation}
          zipCode={zipCode}
          openLocationModal={openUseLocationModal}
        />
        <OfferShowCase
          type='ecommerceOffers'
          loading={isLoadingOffers}
          offers={ecommerceOffers}
          openLocationModal={openUseLocationModal}
        />

        <div className='overflowHidden pb-1'>
          <p className='floatLeft mt-2 titleOfertas'>
            aproveite as ofertas por categorias.
          </p>
          <div
            className='floatRight d-flex color-brand-1 tit-ver-todas-b mt-2'
            onClick={redirectToSearch}
            title='Vai para ofertas por categorias'
          >
            <strong className='mr-1'>ver todas</strong>
            <i className='icon icon-sm icon_right color-brand-1' />
          </div>
        </div>
        <div className='d-flex flex-direct-b'>
          <div className='card card-bairro mt-2'>
            <div className='cardCate cardCateFeatured radius d-flex-mob'>
              <div className='postionBairro'>
                <p className='primer1Bairro'>
                  descontos
                  <br /> em farmácias.
                </p>
                <Link
                  to={`/comunidade-iupp/search/?category=${process.env.REACT_APP_COMUNIDADE_IUPP_FARMACIA}&zipcode=${zipCode}`}
                  title={'Ver Ofertas de Farmácias'}
                >
                  <div className='divOfertas'>
                    <strong className='primer1Bairro'>
                      ver ofertas
                      <i className='icon icon-sm icon_right_app primer1Bairro' />
                    </strong>
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className='card card-bairro mt-2'>
            <div className='cardCate cardBrand1 radius d-flex-mob'>
              <div className='postionBairro'>
                <p className='primer2Bairro'>
                  descontos
                  <br /> em padarias.
                </p>
                <Link
                  to={`/comunidade-iupp/search/?category=${process.env.REACT_APP_COMUNIDADE_IUPP_PADARIA}&zipcode=${zipCode}`}
                  title={'Ver Ofertas de Padarias'}
                >
                  <div className='divOfertas'>
                    <strong className='primer2Bairro'>
                      ver ofertas
                      <i className='icon icon-sm icon_right_app primer2Bairro' />
                    </strong>
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className='card card-bairro mt-2'>
            <div className='cardCate cardUi4 radius d-flex-mob'>
              <div className='postionBairro'>
                <p className='primer1Bairro'>
                  descontos
                  <br /> em supermercados
                </p>
                <Link
                  to={`/comunidade-iupp/search/?category=${process.env.REACT_APP_COMUNIDADE_IUPP_SUPERMERCADO}&zipcode=${zipCode}`}
                  title={'Ver Ofertas de Supermercados'}
                >
                  <div className='divOfertas'>
                    <strong className='primer1Bairro'>
                      ver ofertas
                      <i className='icon icon-sm icon_right_app primer1Bairro' />
                    </strong>
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className='card card-bairro mt-2'>
            <div className='cardCate cardBrand4 radius d-flex-mob'>
              <div className='postionBairro'>
                <p className='primer2Bairro'>
                  descontos
                  <br /> em outras lojas
                </p>
                <div
                  className='divOfertas'
                  onClick={redirectToSearch}
                >
                  <strong className='primer2Bairro'>
                    ver ofertas
                    <i className='icon icon-sm icon_right_app primer2Bairro' />
                  </strong>
                </div>
              </div>
            </div>
          </div>
          <div
            className='btn-cards-mBairro mobile'
            onClick={redirectToSearch}
          >
            Ver todas
          </div>
        </div>
        <div className='overflowHidden pb-1'>
          <p className='floatLeft mt-2 titleOfertas'>
            veja o que tem perto de você.
          </p>
          <div className='floatRight d-flex color-brand-1 tit-ver-todas-b mt-2'>
            <strong
              className='mr-1'
              onClick={redirectToSearch}
            >
              ver todas
            </strong>
            <i className='icon icon-sm icon_right color-brand-1' />
          </div>
        </div>
        <div className='mapa-space'>
          <div className='mapa-meu-bairro mt-2 mb-2'>
            <Maps
              stores={stores}
              offers={physicalOffers}
              styles={{ width: '100%', height: '100%' }}
              google='https://maps.googleapis.com/maps/api'
              geolocation={{
                lat: location.latitude,
                lng: location.longitude
              }}
            />
          </div>
        </div>
        <div
          className='btn-cards-mBairro mobile'
          onClick={redirectToSearch}
        >
          Ver todas
        </div>
      </div>
    </Fragment>
  )
}

const mapStateToProps = state => ({
  storesFilter: Selectors.showCaseStoresFilter(state),
  participant: Selectors.participant(state),
  stores: Selectors.showCaseStores(state),
  physicalOffers: Selectors.getOffers(state, 'physicalOffers'),
  ecommerceOffers: Selectors.getOffers(state, 'ecommerceOffers'),
  useLocation: Selectors.useLocation(state),
  zipCode: Selectors.zipCode(state),
  location: Selectors.location(state),
  isLoadingStores: Selectors.selectRequesting(state, [Actions.REQUEST_GET_SHOWCASE_STORES]),
  isLoadingOffers: Selectors.selectRequesting(state, [
    Actions.REQUEST_GET_SHOWCASE_OFFERS,
    Actions.REQUEST_GET_LOCATION_FROM_ZIP_CODE
  ])
})

const mapDispatchToProps = dispatch => ({
  setLocation: location => dispatch(Actions.setLocation(location)),
  setZipCode: zipCode => dispatch(Actions.setZipCode(zipCode)),
  setUseLocation: value => dispatch(Actions.setUseLocation(value)),
  getStoreShowcase: () => dispatch(Actions.getStoreShowcase()),
  getOfferShowCase: type => dispatch(Actions.getOfferShowCase(type)),
  getLocationFromZipCode: () => dispatch(Actions.getLocationFromZipCode())
})

export default connect(mapStateToProps, mapDispatchToProps)(HomeIupp)

HomeIupp.propTypes = {
  participant: PropTypes.any,
  stores: PropTypes.array,
  physicalOffers: PropTypes.array,
  ecommerceOffers: PropTypes.array,
  useLocation: PropTypes.bool,
  zipCode: PropTypes.string,
  location: PropTypes.string,
  isLoadingStores: PropTypes.bool,
  isLoadingOffers: PropTypes.bool,
  setLocation: PropTypes.func,
  setZipCode: PropTypes.func,
  setUseLocation: PropTypes.func,
  getStoreShowcase: PropTypes.func,
  getOfferShowCase: PropTypes.func,
  getLocationFromZipCode: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/features/MeuBairro/HomeIupp.js